export default __webpack_public_path__ + "static/dark-mode-cat-a6a9dfa18e99154d13c99c4f37840669dbf5f7aca819a0ff28afc72f9dfa6c31.png";